<template>
  <div>
    <LinkTitle />
    <div id="cart">
      <PageSearchTitle :hideCart="true" title="购物车"></PageSearchTitle>
      <div class="cartTitle">
        <div class="cartTitleTop">
          <span class="cartTitleTopTips">已选商品</span>
          <span class="cartTitleTopPrice">&yen;{{totalMoney}}</span>
          <div @click="toCreatOrder" class="cartTitleTopButton">
            <span>结算</span>
          </div>
        </div>
        <div class="cartTitleHr"></div>
      </div>
      <div class="cartBox">
        <div class="cartBoxTitle">
          <ul class="cartBoxTitleTitleUl">
            <li class="cartBoxTitleTitleUlLiMainInfo">
              <div class="cartBoxTitleTitleUlLiMainInfoChecked">
                <el-checkbox @change="changeAllChecked" :value="allChecked"></el-checkbox>
                <span>全选</span>
              </div>
              <div class="cartBoxTitleTitleUlLiMainInfoText">商品信息</div>
            </li>
            <li class="cartBoxTitleTitleUlLiInfo"></li>
            <li class="cartBoxTitleTitleUlLiPrice">
              <span>单价</span>
            </li>
            <li class="cartBoxTitleTitleUlLiNum">
              <span>数量</span>
            </li>
            <li class="cartBoxTitleTitleUlLiMoney">
              <span>金额</span>
            </li>
            <li class="cartBoxTitleTitleUlLiHandle">
              <span>操作</span>
            </li>
          </ul>
        </div>
        <div v-for="(storeItem,index) in cartList" :key="'store_'+index" class="goodsItems">
          <div class="goodsItemsTitle">
            <el-checkbox
              @change="(e)=>changeCartListStore(e,storeItem[0].storeId)"
              :value="storeItemChecked(storeItem)"
            ></el-checkbox>
            <span class="goodsItemsTitleStore">店铺:</span>
            <span>{{storeItem[0].storeName}}</span>
          </div>
          <ul class="goodsItemsProductsBox">
            <li
              v-for="(item,index) in storeItem"
              :key="index"
              :class="['goodsItemsProductsItems',index==0?'':'goodsItemsProductsItemsBorderTop']"
            >
              <div class="goodsItemsProductsItemsCheckeBox">
                <el-checkbox @change="(e)=>itemChangeCheck(e,item)" v-model="item.cart_checked"></el-checkbox>
              </div>

              <div class="goodsItemsProductsItemsMainInfo">
                <img
                  @click="goGoodsDetail(item)"
                  class="goodsItemsProductsItemsMainInfoImg textHover"
                  :src="getImageUrl(item.coverPlan)"
                  alt
                />
                <div
                  @click="goGoodsDetail(item)"
                  class="goodsItemsProductsItemsMainInfoText"
                >{{item.name}}</div>
              </div>

              <div class="goodsItemsProductsItemsInfo">
                <div>
                  <span>产地：{{item.address}}</span>
                </div>
                <div>
                  <span>品种：{{item.breed}}</span>
                </div>
              </div>
              <div class="goodsItemsProductsItemsPrice">
                <span>&yen;{{(item.price).toFixed(2)}}</span>
                <!-- <span class='goodsItemsProductsItemsPriceTips'>{{priceInfo(item)}}</span> -->
              </div>

              <div class="goodsItemsProductsItemsNumber">
                <el-input-number
                  :value="item.cart_num"
                  @change="(e)=>handleStempperChange(e,item)"
                  :min="item.minBuyCount"
                  :max="item.stockCount"
                  size="mini"
                ></el-input-number>
              </div>
              <div class="goodsItemsProductsItemsMoney priceColor">
                <span>&yen;{{(item.price*item.cart_num).toFixed(2)}}</span>
              </div>
              <div class="goodsItemsProductsItemsHandle">
                <span>移入收藏夹</span>
                <span @click="deleteItem(item)">删除</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cartFooter">
      <div class="cartFooterLeft">
        <div class="cartFooterLeftItems">
          <el-checkbox @change="changeAllChecked" :value="allChecked"></el-checkbox>
          <span>全选</span>
        </div>
        <div class="cartFooterLeftItems">
          <span>删除</span>
        </div>
        <div class="cartFooterLeftItems">
          <span>清除失效宝贝</span>
        </div>
        <div class="cartFooterLeftItems">
          <span>移入收藏夹</span>
        </div>
      </div>
      <div class="cartFooterRight">
        <div class="cartFooterRightNum">
          已选商品
          <span class="cartFooterRightNumber">{{totalNum}}</span>件
        </div>
        <div class="cartFooterRightPrice">
          合计:
          <span class="cartFooterRightPriceYen">&yen;</span>
          <span class="cartFooterRightPriceNum">{{totalMoney}}</span>
        </div>
        <div
          @click="toCreatOrder"
          :class="['cartFooterRightButton',totalNum==0?'cartFooterRightButtonDisabled':'']"
        >
          <span>结算</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageSearchTitle from "@/components/components/PageSearchTitle";
import { getImageUrl } from "@/api/api";
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {};
  },

  props: ["gid"],
  components: {
    PageSearchTitle
  },
  created() {
    this.getImageUrl = getImageUrl;
  },
  computed: {
    ...mapState(["cartList", "userInfo"]),
    allChecked() {
      if (this.cartList) {
        return this.cartList.every(item => {
          return item.every(item2 => {
            return item2.cart_checked == true;
          });
        });
      } else {
        return false;
      }
    },
    totalMoney() {
      return this.$getCartInfo(this.cartList).totalMoney.toFixed(2);
    },
    totalNum() {
      return this.$getCartInfo(this.cartList).num;
    }
  },
  methods: {
    ...mapMutations([
      "deleteCartList",
      "changeCartListItem",
      "changeCartListStoreItem",
      "changeCartListAllToChecked",
      "changeCartListItemNum"
    ]),
    changeAllChecked(e) {
      this.changeCartListAllToChecked({ check: e });
    },
    changeCartListStore(e, storeId) {
      this.changeCartListStoreItem({ storeId, check: e });
    },
    toCreatOrder() {
      if (this.totalNum) {
        this.$checkLogin(this.userInfo)
          .then(res => {
            // alert(res)
            this.$router.push("creatOrder");
          })
          .catch(() => {
            this.$router.push("login");
          });
      }
    },
    storeItemChecked(storeItem) {
      return storeItem.every(item => {
        return item.cart_checked == true;
      });
    },
    handleStempperChange(num, { storeId, id }) {
      if (isNaN(num) || num == 0) {
        num = 1;
      }
      this.changeCartListItemNum({ storeId, id, num });
    },
    goGoodsDetail({ id }) {
      this.$router.push({
        name: "goodsDetail",
        query: { goodsId: id, type: -1 }
      });
    },
    deleteItem({ id, storeId }) {
      // console.log(storeId);
      // this.$alert('确认删除?',{
      // this.$confirm('确定吗','提示')
      // console.log(this.$confirm)
      // })
      // this.deleteCartList({id,storeId})
      // console.log(this)
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        // type: "warning"
      })
        .then(() => {
          this.deleteCartList({ id, storeId });
        })
        .catch(() => {});
    },
    itemChangeCheck(e, { id, storeId }) {
      // this.$alert('111')
      console.log(e);
      console.log({ id, storeId });
      this.changeCartListItem({ id, storeId, check: e });
    },
    initData() {
      this.setType();
      let that = this;
      let url = this.type == -1 ? queryGoodsDetailUrl : getGqProductDetail;
      let data =
        this.type == -1 ? { gid: that.goodsId } : { sdId: that.goodsId };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.goods = res.data.data;
            this.images =
              (this.goods.coverPlan ? this.goods.coverPlan : "") +
              (this.goods.image ? "," + this.goods.image : "");
            console.log(this.images);
            console.log(getImageUrl(this.images));
          } else {
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
         this.$alert(JSON.stringify(err))
        });
    },
    priceInfo(item) {
      if (
        item.breed.indexOf("白条") > -1 ||
        item.goodsType.indexOf("白条") > -1
      ) {
        return '(预计)'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1200px){
			  #cart{
          margin:10px 10px 100px!important;
        }
        .cartFooterLeft{
          margin-left: 10px!important
        }
        .cartFooterRight{
          margin-right: 10px!important
        }

        
}

#cart {
  min-height: 100vh;
  margin: 10px 150px 100px;
  min-width: 1000px;
  font-size: 14px;
  color: "#666";
  // background-color: blue;
  .priceColor {
    color: #f40;
    font-weight: 700;
  }
  .cartTitleHr {
    height: 1px;
    background-color: #eee;
  }
  .cartTitleTop {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 60px;
    align-items: center;
    padding-right: 5px;
  }
  .cartTitleTopTips {
    margin-right: 10px;
  }
  .cartTitleTopPrice {
    margin-right: 10px;
    font-size: 14px;
    color: #f40;
  }
  .cartBoxTitleTitleUl {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 60px;
  }
  .goodsItemsProductsItems {
    display: flex;
    flex-direction: row;
    height: 100px;
  }
  .goodsItemsProductsItemsMainInfo {
    display: flex;
    width: 300px;
  }
  .goodsItemsProductsItemsMainInfoImg {
    width: 100px;
    height: 100;
  }

  .goodsItemsProductsItemsMainInfoText {
    width: 190px;
    margin-left: 10px;

    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; //行数
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .goodsItemsProductsItemsMainInfoText:hover {
    color: #f40;
    text-decoration: underline;
    cursor: pointer;
  }
  .goodsItemsProductsItemsInfo {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #666;
  }
  .goodsItemsProductsItemsMoney {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .goodsItemsProductsItemsNumber {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .goodsItemsProductsItemsHandle {
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #333;
    font-size: 14px;
  }
  .goodsItemsProductsItemsHandle span:hover {
    color: #f30;
    text-decoration: underline;
    cursor: pointer;
  }
  .goodsItemsProductsBox {
    border: 1px solid #ccc;
    padding: 10px;
    background-color: #f6f6f6;
  }
  .goodsItemsProductsItemsCheckeBox {
    width: 30px;
    display: flex;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiMainInfo {
    display: flex;
    flex-direction: row;
    width: 340px;
  }
  .cartBoxTitleTitleUlLiMainInfoChecked {
    width: 60px;
  }
  .cartBoxTitleTitleUlLiMainInfoText {
    width: 280px;
    text-align: center;
  }
  .cartBoxTitleTitleUlLiHandle {
    width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiPrice {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cartBoxTitleTitleUlLiInfo {
    flex: 1;
    height: 100%;
  }
  .cartBoxTitleTitleUlLiNum {
    flex: 1;
    text-align: center;
  }
  .cartBoxTitleTitleUlLiMoney {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .goodsItemsProductsItemsPrice {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
  }
  .goodsItemsTitle {
    height: 50px;

    display: flex;
    align-items: center;
  }
  .goodsItemsProductsItemsPriceTips{
    color:#666
  }
  .goodsItemsTitleStore {
    margin: 0 10px;
  }
  .goodsItemsProductsItems {
    padding: 15px 0;
  }
  .goodsItemsProductsItemsBorderTop {
    border-top: 1px solid #eeeeee;
  }
  .cartTitle {
    margin-top: 10px;
  }
}


.cartFooter {
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  background-color: #fff;
  display: flex;
  height: 60px;
  justify-content: space-between;
  width: 100%;
  padding-right: 150px;
  font-size: 14px;
  color: #666;
}
.cartFooterLeft {
  display: flex;
  align-items: center;
}

.cartFooterLeft {
  padding-left: 10px;
  margin-left: 150px;
  flex: 1;
  min-width: 500px;
  background-color: #e5e5e5;
}
.cartFooterRight {
  width: 600px;
  background-color: green;
  margin-right: 150px;
  flex: 1;
  min-width: 500px;
  background-color: #e5e5e5;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.cartFooterLeftItems {
  margin-right: 15px;
}
.cartFooterLeftItems:hover {
  text-decoration: underline;
  cursor: pointer;
}
.cartFooterRightNum,
.cartFooterRightPrice {
  margin-left: 30px;
}
.cartFooterRightButton {
  margin-left: 30px;
  height: 100%;
  background-color: #f40;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
}
.cartFooterRightButton:hover {
  cursor: pointer;
}

.cartFooterRightButtonDisabled {
  background-color: #999;
}
.cartFooterRightButtonDisabled:hover {
  cursor: not-allowed;
}

.cartFooterRightNumber {
  font-size: 16px;
  color: #f40;
  margin: 0 5px;
}
.cartFooterRightPriceYen {
  color: #f40;
}
.cartFooterRightPriceNum {
  color: #f40;
  font-size: 16px;
  font-weight: 700;
}
.cartTitleTopButton {
  background-color: #f40;
  width: 50px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  border-radius: 2px;
  font-size: 12px;
}
.cartTitleTopButton:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Cart/Cart.vue